<template>
  <div class="methodes">
    <subNav :subnavstep="subnavstep"></subNav>
    <headerFeedback
      :count="count"
      :tekst="schermtekst"
      :selected="countSelected"
      :slug="slug"
      :methods="selectedMethods"
      ref="headerFeedback"
      @showAlert="countSelected = $event"
    />
    <div class="methodes-overzicht">
      <MethodeCard
        @updateCount="onUpdateCount"
        v-for="(cardRecord, index) in methodes"
        :key="cardRecord.i"
        :data-index="index"
        :card="cardRecord"
        :slug="slug"
        :storeIndex="storeIndex"
        :storeMethods="storeMethods"
      ></MethodeCard>
    </div>

    <div class="page-footer solo" v-if="countSelected > 0">
      <router-link
        :to="{
          name: 'vergelijkMethodes',
          params: { doelSlug: slug, methods: selectedMethods },
        }"
        class="button"
        >Vergelijk methodes (<span class="methodes_selection_count">{{
          countSelected
        }}</span
        >)</router-link
      >
    </div>
  </div>
</template>

<script>
import subNav from "../components/subNav.vue";
import headerFeedback from "../components/headerFeedback.vue";
import MethodeCard from "../components/MethodeCard.vue";

const ENDPOINT_NAME = "ppw/v1/methodes";
const axios = require("axios");

export default {
  name: "methodes",

  data() {
    return {
      isLoading: true,
      isEmptyResult: false,
      methodes: [],
      storeMethods: [],
      methodeArray: [],
      storeIndex: 0,
      selectedMethods: [],
      countSelected: 0,
      count: 0,
      step: "methodesoverzicht",
      subnavstep: "methodes",
      schermtitel: "",
      schermtekst: "",
      slug: "",
      doel: "",
      pushers: [],
    };
  },

  components: {
    MethodeCard,
    subNav,
    headerFeedback,
  },

  methods: {
    getMethodeCards() {
      const doelSlug = this.$route.params.doelSlug;
      const url = new URL(
        process.env.VUE_APP_REST_URL + ENDPOINT_NAME + "?doelSlug=" + doelSlug
      );
      this.isLoading = true;
      this.isEmptyResult = false;

      // fetch(url)
      axios
        .get(url)
        .then((r) => {
          const results = r.data;
          if (!results) {
            this.methodes = [];
            this.count = 0;
            this.isEmptyResult = true;
          } else {
            this.step = r.data.scherm;
            this.schermtekst = r.data.schermtekst;
            this.doel = r.data.doel;
            this.methodes = r.data.methodes;
            // check of methode geselecteerd is (localStorage array)
            this.count = parseInt(r.data.count);
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    setSelected() {
      try {
        this.storeMethods = JSON.parse(localStorage.getItem("comparedItems"));
        // find the index for this goal
      } catch (e) {
        alert("oeps, er gaat iets fout");
      }
      this.countSelected = this.storeMethods[this.storeIndex].methods.length;
      this.selectedMethods = this.storeMethods[this.storeIndex].methods;
    },

    // update count and array selected methods for comparison page
    onUpdateCount(countVal) {
      this.countSelected = countVal;
      // check localstorage exists?
      this.selectedMethods = this.storeMethods[this.storeIndex].methods;
    },
  },

  computed: {
    storeAtts() {
      this.storeMethods = JSON.parse(localStorage.getItem("comparedItems"));
      for (let i = 0; i < this.storeMethods.length; i++) {
        if (this.storeMethods[i].slug == sluggie) {
          this.storeIndex = i;
          this.countSelected = this.storeMethods[i].methods.length;
        }
      }
    },
  },

  created() {
    setTimeout(() => this.getMethodeCards(), 50);
    if (localStorage.getItem("comparedItems")) this.setSelected();
    this.slug = localStorage.getItem("slug");
  },

  mounted() {
    const sluggie = this.$route.params.doelSlug;

    if (localStorage.getItem("comparedItems")) {
      try {
        this.storeMethods = JSON.parse(localStorage.getItem("comparedItems"));
        // ok, zit dit doel al in de localstorage?
        let index = -1;
        for (let i = 0; i < this.storeMethods.length; i++) {
          if (this.storeMethods[i].slug == sluggie) index = i;
        }
        if (index < 0) {
          this.storeMethods.push({
            slug: sluggie,
            methods: [],
          });
          // create separate key for this goal to store checked methods
          const parsed = JSON.stringify(this.storeMethods);
          localStorage.setItem("comparedItems", parsed);
        }
      } catch (e) {
        alert("oeps, er gaat iets fout");
      }
    } else {
      this.storeMethods.push({
        slug: sluggie,
        methods: [],
      });
      // create separate key for this goal to store checked methods
      const parsed = JSON.stringify(this.storeMethods);
      localStorage.setItem("comparedItems", parsed);
      this.storeMethods = JSON.parse(localStorage.getItem("comparedItems"));
    }
    // again, because this goal could be new in the storeMethods array
    this.storeIndex = 0;
    for (let i = 0; i < this.storeMethods.length; i++) {
      if (this.storeMethods[i].slug == sluggie) {
        this.storeIndex = i;
        this.countSelected = this.storeMethods[i].methods.length;
      }
    }
  },
};
</script>

